import Page2023 from './Page2023';
export default Page2023;
